
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_91_46_46_46unit_93_9393ORNGdjOc5xQYk3wV9Vd7YKMKTT2rrMs0rcfl7sVYIMeta } from "/home/xjenek/oef/pages/[[...unit]].vue?macro=true";
import { default as _91asset_93Z7q525xgSJdXXMXNDCwN_45PCPsv4xCqeR44NE8psDDMYMeta } from "/home/xjenek/oef/pages/asset/[asset].vue?macro=true";
import { default as _91address_931dxjLKVizd3OQhhLrX9xq3W_45rphRkXMs91posrsmoMQMeta } from "/home/xjenek/oef/pages/address/[address].vue?macro=true";
export default [
  {
    name: "unit",
    path: "/:unit(.*)*",
    meta: _91_91_46_46_46unit_93_9393ORNGdjOc5xQYk3wV9Vd7YKMKTT2rrMs0rcfl7sVYIMeta || {},
    component: () => import("/home/xjenek/oef/pages/[[...unit]].vue")
  },
  {
    name: "asset",
    path: "/asset/:asset(.*)",
    meta: _91asset_93Z7q525xgSJdXXMXNDCwN_45PCPsv4xCqeR44NE8psDDMYMeta || {},
    component: () => import("/home/xjenek/oef/pages/asset/[asset].vue")
  },
  {
    name: "address-address",
    path: "/address/:address()",
    component: () => import("/home/xjenek/oef/pages/address/[address].vue")
  }
]